import theme from "@monorepo/styles/theme";

export const CardStyle = {
  width: "100%",
  borderRadius: 2,
  border: "1px solid",
  borderColor: theme.palette.primary.main,
  backgroundColor: theme.palette.background.default,
  marginBottom: 2,
  padding: 0,
};

export const ButtonStyle = (isUsed: boolean) => {
  return {
    padding: 1,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    backgroundColor: isUsed ? theme.palette.grey[300] : "",
  };
};
